import React, { Component } from 'react'
import FormConsultaCpaAbandonada from './FormConsultaCpaAbandonada'

class ConsultaCpaAbandonada extends Component {
  render () {
    return (
      <div id='consulta-cupo-container'>
        <FormConsultaCpaAbandonada />
      </div>
    )
  }
}

export default ConsultaCpaAbandonada
